import { useState } from "react";

import { Toggle } from "@shared/components/Toggle";

import clsx from "clsx";

interface HelpWrapperProps {
  showToggle?: boolean;
  buttonText?: React.ReactNode;
  headerText: React.ReactNode;
  steps?: React.ReactNode[];
  footerText?: React.ReactNode;
}

export function HelpWrapper(props: HelpWrapperProps) {
  const [showHelp, setShowHelp] = useState(false);
  const { showToggle = true } = props;

  return (
    <>
      {showToggle && (
        <Toggle
          open={showHelp}
          onClick={() => setShowHelp((v) => !v)}
          buttonText={props.buttonText}
        />
      )}
      {(!showToggle || showHelp) && (
        <div
          className={clsx("flex flex-col gap-y-4", {
            "mt-4": showToggle,
          })}
        >
          <p>{props.headerText} </p>
          {props.steps && props.steps.length > 0 && (
            <ol className="list-decimal list-outside pl-5 space-y-3">
              {props.steps.map((step, i) => (
                <li key={i}>{step}</li>
              ))}
            </ol>
          )}
          {props.footerText && <p>{props.footerText}</p>}
        </div>
      )}
    </>
  );
}
